import { FC } from "react";
import { ReactComponent as EyeSlashIcon } from "./eye-crossed-out.svg";

const HiddenBadgeIcon: FC = () => <EyeSlashIcon />;

export default HiddenBadgeIcon;
